import type { ConfirmingRequestForCreation } from '../types';

export const createRequestForCreation = (
  selectedDocuments: any[],
  editingRequest: any,
  requestConfiguration: any,
  productType: 'traditional' | 'earlyPayment',
  operationDateDate: Date,
  subProductConditions: {
    fundRate: number;
  },
): ConfirmingRequestForCreation => {
  const documentsForRequest = selectedDocuments.map((document: any) => {
    const date =
      typeof document.paymentDate === 'string'
        ? new Date(document.paymentDate)
        : document.paymentDate;
    return {
      id: document.id,
      amount: document.amount,
      amountDocument: 0,
      amountFinanced: 0,
      amountRetention: 0,
      businessIdentifier: document.businessIdentifier,
      businessName: document.businessName,
      issuer: document.issuer,
      issuedDate: document.issuedDate,
      receiptDate: document.receiptDate,
      issuedDateShortString: document.issuedDate.split('T')[0],
      daysToCount: document.daysToCount,
      confirmDate: document.confirmDate,
      cedded: 'No cedido',
      folio: document.folio,
      paymentDate: date,
      paymentDateString: date.toISOString(),
      paymentDateShortString: date.toISOString().split('T')[0],
      subProductName: undefined, // TODO: ?
      cancelDate: document.cancelDate,
      stakeholderName: document.stakeholderName,
      stakeholderIdentifier: document.stakeholderIdentifier,
      active: true,
      code: document.code,
      userOwnerId: document.executive,
    };
  });

  const documents = documentsForRequest.flat();

  let request;
  if (editingRequest) {
    request = {
      id: editingRequest.id,
      advance: 100,
      rate: editingRequest.rate,
      arrearType: editingRequest.arrearType,
      arrearRate: editingRequest.arrearRate,
      arrearTableId: editingRequest.arrearTableId,
      expensesHasIva: editingRequest.expensesHasIva,
      stakeholderIdentifier: editingRequest.stakeholderIdentifier,
      stakeholderName: editingRequest.stakeholderName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      subProduct: 'electronic-invoice-confirming', // TODO: HARDCODED
      subProductName: 'Factura electrónica confirming', // TODO: HARDCODED
      productType: editingRequest.type,
      documents: documents,
      requestDate: operationDateDate.toISOString(),
      operationCostComissionFixed: editingRequest.operationCostFixed,
      operationCostVariable: editingRequest.operationCostVariable,
      operationCostComissionVariablePercentage:
        editingRequest.operationCostVariablePercentage,
      expensesCost: editingRequest.expensesCost,
      userOwnerId: editingRequest.executive,
      exchangeDays: editingRequest.exchangeDays,
      fundRate: editingRequest.fundRate || 0,
    };
  } else {
    request = {
      id: null,
      advance: 100,
      rate: 0,
      arrearType: 'lineal',
      arrearRate: requestConfiguration.arrearRate,
      arrearTableId: null,
      expensesHasIva: requestConfiguration.expensesHasIVA || false,
      stakeholderIdentifier: documents[0].stakeholderIdentifier,
      stakeholderName: documents[0].stakeholderName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      subProduct: 'electronic-invoice-confirming', // TODO: HARDCODED
      subProductName: 'Factura electrónica confirming', // TODO: HARDCODED
      productType: productType,
      documents: documents,
      requestDate: operationDateDate.toISOString(),
      userOwnerId: documents[0].userOwnerId,
      exchangeDays: requestConfiguration.exchangeDays,
      fundRate: subProductConditions.fundRate || 0,
    };
  }
  return request;
};
